type TScriptData = {
  code: number;
  message: string;
};

enum TEnableDarkMode {
  ON = 1,
  OFF = 0,
  FORCE = 'force',
}

enum TEnableAged {
  ON = 1,
  OFF = 0,
  FORCE = 'force',
}

type TSdkOpts = {
  width: number;
  height: number;
};

type TCaptchaOptions = {
  bizState?: any;
  enableDarkMode?: TEnableDarkMode;
  enableAged?: TEnableAged;
  sdkOpts?: TSdkOpts;
  ready?: () => void;
  userLanguage?: string;
  type?: string, // 全屏模式 full
  showHeader?: boolean, // 隐藏全屏模式的头部 false
};

export default class QCaptcha {
  appid = '';
  callback: () => void;
  options = {};
  captcha = {
    show: Function,
    hide: Function,
    destroy: Function,
    getTicket: Function,
  };

  constructor(appid: string, callback: () => void, options: TCaptchaOptions) {
    this.appid = appid;
    this.callback = callback;
    this.options = options;
  }

  public async show() {
    await this.create();
    this.captcha.show();
  }

  public hide() {
    this.captcha.destroy();
  }

  public destroy() {
    this.captcha.destroy();
  }

  public getTicket() {
    this.captcha.getTicket();
  }

  /**
   * 是否（适老）关怀模式
   * @returns Boolean
   */
   private isElderlyMode() {
    const userAgent = window.navigator.userAgent;
    return userAgent.indexOf('CurrentMode/3') > -1;
  }

  /**
   * 防水墙脚本加载
   * @returns TScriptData
   */
  private loadScript(): Promise<TScriptData> {
    return new Promise((resolve, reject) => {
      const bodyTag = document.querySelector('body');
      const script = document.createElement('script');
      script.src = 'https://ssl.captcha.qq.com/TCaptcha.js';
      script.type = 'text/javascript';
      script.defer = true;
      script.onload = () => {
        resolve({
          code: 0,
          message: 'success',
        });
      };
      script.onerror = () => {
        reject({
          code: -1,
          message: `loadScript fails url: ${script.src} `,
        });
      };
      bodyTag?.appendChild(script);
    });
  }
  /**
   * 初始化防水墙
   */
  private async initCaptcha(appid: string, callback: () => void, options: TCaptchaOptions) {
    const result = await this.loadScript().catch(e => {
      return e;
    });
    
    // 脚本加载失败
    if (result.code !== 0) {
      console.error('[initCaptcha] loadScript fails', result.message);
      return;
    }

    // 默认参数
    let defaultOptions = {};
    if (this.isElderlyMode()) {
      defaultOptions = {
        enableAged: 'force', // true | 'force'
      }
    } else {
      defaultOptions = {
        enableAged: true,
      }
    }
    // 初始化防水墙实例
    this.captcha = await new window.TencentCaptcha(appid, callback, {
      ...defaultOptions,
      ...options,
    });
  }

  private async create() {
    await this.initCaptcha(this.appid, this.callback, this.options);
  }
}
